<!-- 标题字体 -->
<template>
  <div id='appDisplay'>
    <h1 class="app-bold banner-title">{{text}}</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['text']
}
</script>
<style scoped lang='scss'>
.app-bold {
  font-weight: 400;
}
.banner-title{
  font-size: vw(88);
}
@include isMobile {
  .banner-title{
    font-size: rem(44);
  }
}
</style>
